import axios from 'axios';
// import store from '../store';
import router from '../router';
import { Message, Notification } from 'element-ui'
axios.defaults.baseURL = '/api';
// var loadinginstace;
//自定义配置axios的拦截器
axios.interceptors.request.use(
    config => {
        // loadinginstace = Loading.service({ fullscreen: true });
        if (config.method == 'post' && config.data) {
            //分页参数处理成url连接参数
            let pageParam = '';
            let pageNum = config.data.pageNum;
            if (pageNum !== undefined && pageNum != null) {
                pageParam += ('pageNum=' + pageNum);
            }

            let pageSize = config.data.pageSize;
            if (pageSize !== undefined && pageSize != null) {
                pageParam += (pageParam.length == 0 ? "" : "&" + ('pageSize=' + pageSize));
            }

            pageParam = (config.url.includes('?') ? "" : "?") + pageParam;
            config.url += pageParam;
        }
        return config;
    },
    err => {
        return Promise.reject(err);
        // loadinginstace.close();
    }
);

axios.interceptors.response.use(
    response => {
        // loadinginstace.close();
        // 400为通用错误提示
        if (response.data.code === 400 || response.data.code === 401) {
            Message({
                message: response.data.errMsg,
                type: 'warning'
            });
        }
        //请求成功的、需要自行处理异常的，对响应进行拆包，返回自定义包装类
        return Promise.resolve(response.data);
    },
    err => {
        // loadinginstace.close();

        if (err && err.response && err.response.status === 403) {
            // router.replace("/login");
            // JSON.stringify(store.state.userInfo) === '{}' ?  : router.replace("/403");
        } else if (err && err.response && err.response.status === 500) {
            Notification.error({
                title: '温馨提示',
                message: '你的网络不通，请及时联系管理员'
            });
        } else {
            Message({
                message: '请求错误,请稍后再试',
                type: 'warning'
            });
        }
        return Promise.reject(err);
    }
);

export default axios;